const THRESHOLD = 160;

export function areDevToolOpen() {
    const width = window.outerWidth - window.innerWidth > THRESHOLD;
    const height = window.outerHeight - window.innerHeight > THRESHOLD;

    return width || height;
}
